var _circle, _path, _path2, _rect, _rect2, _rect3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlantStudyLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.1104,
    cy: 47.1104,
    r: 28.1104,
    fill: "#E5E7ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3933 56.4097H28.7567V35.5556H55.2983V38.4352C56.0115 38.3589 56.7359 38.3197 57.4694 38.3197C58.0149 38.3197 58.5553 38.3414 59.0899 38.3839V29.8682C59.0899 28.8626 58.6904 27.8981 57.9794 27.1871C57.2683 26.476 56.3039 26.0765 55.2983 26.0765H53.4024V22.2849H49.6108V26.0765H34.4442V22.2849H30.6526V26.0765H28.7567C26.6524 26.0765 24.9651 27.7638 24.9651 29.8682V56.4097C24.9651 57.4153 25.3646 58.3797 26.0756 59.0908C26.7867 59.8019 27.7511 60.2013 28.7567 60.2013H37.3565C37.3099 59.6414 37.2861 59.075 37.2861 58.503C37.2861 57.7962 37.3224 57.0978 37.3933 56.4097Z",
    fill: "#152C73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6962 65.8073L54.1654 55.3381L60.3783 61.5511L71.3078 50.6216",
    stroke: "#6F4CDA",
    strokeWidth: 2.79041
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.8897,
    y: 38.2226,
    width: 4.98394,
    height: 4.98394,
    fill: "#152C73"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5873,
    y: 46.9821,
    width: 3.58874,
    height: 3.58874,
    fill: "#6F4CDA",
    stroke: "#6F4CDA",
    strokeWidth: 1.3952
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9498,
    y: 38.2226,
    width: 4.98394,
    height: 4.98394,
    fill: "#152C73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7342 46.5651C54.5917 46.5651 51.5779 47.8134 49.3558 50.0355C47.1337 52.2576 45.8853 55.2715 45.8853 58.414C45.8853 61.5565 47.1337 64.5703 49.3558 66.7924C51.5779 69.0145 54.5917 70.2629 57.7342 70.2629C60.8767 70.2629 63.8905 69.0145 66.1126 66.7924C68.3347 64.5703 69.5831 61.5565 69.5831 58.414C69.5831 55.2715 68.3347 52.2576 66.1126 50.0355C63.8905 47.8134 60.8767 46.5651 57.7342 46.5651ZM41.1458 58.414C41.1458 55.7865 41.7699 53.1966 42.9668 50.8576C44.1636 48.5185 45.899 46.4973 48.03 44.9602C50.1609 43.4231 52.6265 42.4142 55.2237 42.0166C57.821 41.619 60.4755 41.844 62.9687 42.6731C65.4619 43.5022 67.7225 44.9117 69.5644 46.7855C71.4063 48.6593 72.7767 50.9438 73.5628 53.4509C74.3489 55.958 74.5282 58.616 74.086 61.206C73.6438 63.796 72.5927 66.2439 71.0192 68.3481L78.3679 75.6944L75.017 79.0476L67.6707 71.7013C65.205 73.5458 62.2745 74.6676 59.2074 74.941C56.1403 75.2145 53.0576 74.6289 50.3045 73.2497C47.5513 71.8706 45.2364 69.7523 43.6189 67.1321C42.0013 64.5119 41.145 61.4932 41.1458 58.414Z",
    fill: "#152C73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantStudyLogo);
export default __webpack_public_path__ + "static/media/plant-study-logo.e9a50892c0007bf459f85c591557e9cc.svg";
export { ForwardRef as ReactComponent };